var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from '../../../helpers/createNumberMask';
const DecimalField = (_a) => {
    var { maskoptions } = _a, props = __rest(_a, ["maskoptions"]);
    const defaultmaskoptions = {
        prefix: '',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 20, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
    };
    const mask = createNumberMask(Object.assign(Object.assign({}, defaultmaskoptions), maskoptions));
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(MaskedInput, Object.assign({ mask: mask }, props));
};
export default DecimalField;
